import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SearchCompanyComponent } from '../../admin/seach-company/search-company.component';
import { AdminService } from '../../../services/admin.service';
import { UserDialogData } from '../add-user-company-dialog/add-user-company-dialog.component';
import { SearchDataserviceComponent } from "../../admin/seach-dataservice/search-dataservice.component";
import { DataService, GetDataService } from '../../../interfaces/DataService';
import { ServerResponse, ServerResponseObject } from '../../../interfaces/ServerResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NotifyDialogService } from '../../../services/notify-dialog.service';
import { ARE_YOU_SURE, SURE_REMOVE_DATASERVICE } from '../../../shared/strings';

export interface CompanyValue {
  company: string;
}

@Component({
  selector: 'app-add-user-dataservice-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    SearchCompanyComponent,
    SearchDataserviceComponent,
    MatTableModule
],
  templateUrl: './add-user-dataservice-dialog.component.html',
  styleUrl: './add-user-dataservice-dialog.component.scss'
})
export class AddUserDataserviceDialogComponent implements AfterViewInit{

  companyDisplayedColumns: string[] = [
    'id',
    'name',
    'type',
    'actions'
  ];

  addUserDataServiceForm = new FormGroup({
    company_id: new FormControl('', [Validators.required]),
    dataservice_id: new FormControl('', [Validators.required]),
  });

  selectedCompany: CompanyValue = { company: "" };

  isDataserviceLoading: boolean = false;
  dataservicesDataSource = new MatTableDataSource<GetDataService>();
  seletedDataservice!: GetDataService;

  @ViewChild(SearchDataserviceComponent) searchDataservice!: SearchDataserviceComponent;

  constructor(private adminService: AdminService, private notifyDialogService: NotifyDialogService) {
    this.getUserDataservice();
  }

  ngAfterViewInit(): void {
    this.addUserDataServiceForm.controls['dataservice_id'].disable();
  }

  private readonly dialogRef = inject(MatDialogRef<AddUserDataserviceDialogComponent>, { optional: true });
  data = inject<UserDialogData>(MAT_DIALOG_DATA);

  isLoading: boolean = false;

  onSelectCompany = () =>{
    this.selectedCompany.company = this.addUserDataServiceForm.value.company_id!;
    this.searchDataservice.getDataserviceList("");
    this.addUserDataServiceForm.controls['dataservice_id'].enable();
  }

  onAddUserDataService(){
    if(!this.addUserDataServiceForm.valid)return;
    let company_id = this.addUserDataServiceForm.value.company_id;
    let dataservice_id = this.addUserDataServiceForm.value.dataservice_id;
    this.isLoading = true;
    this.adminService.addUserDataservice(company_id!, dataservice_id!, this.data.email).subscribe({
      next:(ref: any)=>{
        this.getUserDataservice();
        this.addUserDataServiceForm.reset();
        this.isLoading = false;
      },
      error: ()=>{
        this.isLoading = false;
      }
    });
  }

  getUserDataservice(){
    this.isDataserviceLoading = true;
    this.adminService.getUserDataservice(this.data.email).subscribe({
      next: (res: ServerResponse<GetDataService>)=>{
        this.dataservicesDataSource.data = res.result;
        this.isDataserviceLoading = false;
      },
      error: ()=>{
        this.isDataserviceLoading = false;
      },
    });
  }

  onDeleteDataservice(dataservice: GetDataService) {
    this.seletedDataservice = dataservice;
    this.notifyDialogService.openDialog(ARE_YOU_SURE, SURE_REMOVE_DATASERVICE.replace("${}", this.seletedDataservice.name), true, () => {
      this.removeUserDataservice();
    });
  }

  removeUserDataservice() {
    this.isDataserviceLoading = true;
    this.adminService.removeUserDataService(this.seletedDataservice.company_id, this.seletedDataservice.id, this.data.email).subscribe({
      next: (res: ServerResponseObject<any>) => {
        this.isDataserviceLoading = false;
        this.getUserDataservice();
      },
      error: () => {
        this.isDataserviceLoading = false;
      }
    });
  }
}
